
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import _shuffle from 'lodash/shuffle';
import _cloneDeep from 'lodash/cloneDeep';
import Medias from '@/@next/services/Medias';
import { messages } from '@/@next/i18n';
import { TimelineContentData } from '@/@types/graphql';
import CTimelineFullScreenEvent from './TimelineFullScreenEvent.vue'
import CTimelineFullScreenSlider from './TimelineFullScreenSlider.vue';

const config = {
  name: 'c-timeline-full-screen',
  i18n: { messages },
  components: {
    CTimelineFullScreenEvent,
    CTimelineFullScreenSlider
  }
};

@Component(config)
export default class CTimelineFullScreen extends Mixins(Medias) {
  @Prop({ type: Object, required: true }) timeline!: TimelineContentData
  @Prop({ type: Number, required: false, default: 0 }) current!: number

  localCurrent: number = this.current

  mounted () {
    this.localCurrent = this.current
  }

  get title () {
    return this.timeline?.i18n?.title?.value || null;
  }

  get events () {
    return this.timeline?.events || [];
  }

  get event () { 
    return this.events[this.localCurrent];
  }

  select (i: number) {
    this.$emit('select', i)
    this.localCurrent = i;
  }

}
